import { isNativeApp } from 'infra/services/native-bridge';

export const SURFACE_ENUM = {
	APP: 'app',
	MOBILE_WEB: 'mobile_web',
	WEB: 'web',
} as const;

export type Surface = (typeof SURFACE_ENUM)[keyof typeof SURFACE_ENUM];

const MOBILE_MAX_WIDTH = 1024;

export const getViewportWidth = (): number | null =>
	typeof window === 'undefined' ? null : window.innerWidth;

export const resolveSurface = (): Surface => {
	if (isNativeApp()) return SURFACE_ENUM.APP;

	const viewportWidth = getViewportWidth();
	if (viewportWidth !== null && viewportWidth < MOBILE_MAX_WIDTH) {
		return SURFACE_ENUM.MOBILE_WEB;
	}

	return SURFACE_ENUM.WEB;
};
